import React from "react";

export default function RowHeading({ candidate, party, className, bioUrl }) {
  return (
    <td className={`rowHeading ${className}`}>
      {bioUrl && (
        <a href={bioUrl} alt="bio" target="_blank" rel="noopener noreferrer">
          <span className="candidate">{candidate}</span>
        </a>
      )}
      {!bioUrl && <span className="candidate">{candidate}</span>}
      {party && (
        <>
          <br />
          {party}
        </>
      )}
    </td>
  );
}
